import React from "react";
import { useState, useEffect } from "react";

// Third party
import { Link, useNavigate } from "react-router-dom";
import {isMobile} from 'react-device-detect';
import uuid from 'react-uuid';
import Cookies from 'universal-cookie';
import ReactGA from "react-ga4";

// Custom Components
import TextInput from "../../../UI/TextInput";

// Redux
import { useDispatch } from "react-redux";

// Api
import useAxiosNoAuth from "../../../../Hooks/useAxiosNoAuth";

// Reducer
import { setUserUid } from "../../../../Store/Reducer/Authentication/Authentication";

// Helper
import { baseURL, isRequired, validateEmail, getAuth } from "../../../../Utils";
import {logAnalyticEvent} from "../../../../index";

// Images
import logo2 from "../../../../Assets/images/logo2.svg";

// CSS
import "../../../../Assets/css/login.css";
import "../../../../Assets/css/custom.css";

function Login() {
  const cookies = new Cookies();

  const [emailAddress, setEmailAddress] = useState("");
  const [emailAddressErr, setEmailAddressErr] = useState("");
  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [commonErr, setCommonErr] = useState("");
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const noAuthapi = useAxiosNoAuth();

  const handleFormOnChange = (e) => {
    const { name, value } = e.target;
    setCommonErr("");
    switch (name) {
      case "EmailAddress":
        setEmailAddressErr("");
        setEmailAddress(value);
        break;
      case "password":
        setPasswordErr("");
        setPassword(value);
        break;
      default:
        break;
    }
  };
  const isFormValid = () => {
    let isValid = true;
    if (isRequired(emailAddress)) {
      setEmailAddressErr("Email Address is required");
      isValid = false;
    } else if (!validateEmail(emailAddress)) {
      setEmailAddressErr("Please enter a valid email address.");
      isValid = false;
    }
    if (isRequired(password)) {
      setPasswordErr("Password is required");
      isValid = false;
    }
    return isValid;
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (isFormValid()) {
      setBtnLoader(true);
      let web_cookie;
      if(cookies.get('device_id') === undefined || cookies.get('device_id') === '' || cookies.get('device_id') === null) {
        web_cookie = uuid()
        cookies.set('device_id', JSON.stringify(web_cookie));
      }else{
        web_cookie = cookies.get('device_id')
      }
      noAuthapi
        .post(
          `${baseURL}/login/`,
          {
            email: emailAddress,
            password: password,
            web_cookie: web_cookie
          },
          { "Access-Control-Allow-Origin": "*" }
        )
        .then(function (response) {
          dispatch(setUserUid(response.data.data));
          localStorage.setItem(
            "useruid",
            JSON.stringify(response.data?.userid)
          );
          localStorage.setItem("auth", JSON.stringify(response.data.data));
          localStorage.setItem(
            "fl",
            JSON.stringify(response.data.data.first_login)
          );
          localStorage.setItem("ov", true);

          if (response.data.data?.change_password_on_next_login === true) {
            localStorage.setItem("cp", true);
            navigate("/change-password");
          } else {
            if (response.data.data.first_login === true) {
              navigate("/complete-signup");
            } else {
              navigate("/home");
            }
          }
          setBtnLoader(false);
        })
        .catch(function (error) {
          if (error?.response?.status === 401) {
            if (error?.response?.data?.message) {
              setCommonErr(error?.response?.data?.message);
            } else {
              setCommonErr("You have entered an invalid username or password");
            }
          } else if (error?.response?.status === 500) {
            setCommonErr("Log in failed. Please contact support");
            error?.message !== "canceled" && logAnalyticEvent({
              category: "api_error",
              action: "error in login api",
              label:error
            });

          } else {
            if (error?.response?.data?.message) {
              setCommonErr(error?.response.data.message);
            } else {
              setCommonErr("Log in failed. Please contact support");
            }
            error?.message !== "canceled" && logAnalyticEvent({
              category: "api_error",
              action: "error in login api",
              label:error
            });
          }
          setBtnLoader(false);
        });
    }
  };

  const listener = (event) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      event.preventDefault();
      handleLogin(event);
    }
  };

  //Nick: when a mobile user types in /login in his browser, he will be redirected to /mobile.
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if(isMobile){
        navigate('/mobile')
      }
    }
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
    return () => (mounted = false);
  }, []);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      localStorage.removeItem("useruid");
      let token = getAuth();
      if (token) {
        setIsAuthenticated(true);
        navigate("/home");
      }
    }
    return () => (mounted = false);
  }, [isAuthenticated]);

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  });

  return (
    <div className="cf_login_wrapper">
      <div className="cf_login_inner">
        <div className="cf_login_block">
          <div className="cf_login_logoBlock">
            <img src={logo2} alt="Cafetra" className="img-fluid" />
          </div>
          <h3>Log into your account</h3>
          <div
            className={
              emailAddressErr ? "cf_form_block error" : "cf_form_block success"
            }
          >
            <TextInput
              type="email"
              name="EmailAddress"
              value={emailAddress}
              placeholder="Enter email"
              classNameStyle="cf_form_field"
              maxLength={320}
              onChange={(e) => handleFormOnChange(e)}
              autoComplete="true"
            />
            <span className="cf_icon cf_mail_green"></span>
            {emailAddressErr ? (
              <span className="response_message error">{emailAddressErr}</span>
            ) : (
              ""
            )}
          </div>
          <div
            className={
              passwordErr ? "cf_form_block error" : "cf_form_block success"
            }
          >
            <TextInput
              type={showPassword ? "text" : "password"}
              name="password"
              maxLength={256}
              placeholder="Enter password"
              classNameStyle="cf_form_field"
              onChange={(e) => handleFormOnChange(e)}
            />
            <span
              onClick={() => {
                handleClickShowPassword();
              }}
              className={
                showPassword
                  ? "cf_icon cf_eye_green cf_eye_green_close"
                  : "cf_icon cf_eye_green"
              }
            ></span>
            {passwordErr ? (
              <span className="response_message error">{passwordErr}</span>
            ) : (
              ""
            )}
          </div>
          <div className="cf_form_block">
            <div className="cf_flex_box">
              <div className="cf_forgot_block">
                <Link to={"/forgot"}>Forgot Password?</Link>
              </div>
            </div>
          </div>
          <div className="cf_form_block">
            <button onClick={(e) => handleLogin(e)} className="cf_btn">
              {!btnLoader ? (
                "Login"
              ) : (
                <i className="fa fa-circle-o-notch fa-spin"></i>
              )}
            </button>
          </div>
          <div className={commonErr ? "cf_form_block error" : ""}>
            {commonErr ? (
              <span className="response_message error">{commonErr}</span>
            ) : (
              ""
            )}
          </div>
          <p className="cf_redirect">
            Don't have an account? <Link to={"/trial"}>Book a demo</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
